import { ResponsiveGrid, Tab } from '@alifd/next';
import React from 'react';

import PageHeader from '@/components/PageHeader';

import Fix from '../Fix/components/FixList';
import LeaseManagement from '../LeaseManagement/components/LeaseManagementList';
import PointManagement from '../PointManagement/components/PointManagementList';
import PublicAppointmentHomepage from '../PublicAppointmentHomepage/components/PublicAppointmentList';
import RealEstateAgentManagement from '../RealEstateAgentManagement';
import ResidentAccountNumbers from '../ResidentAccountNumbers/components/AddResidentAccountNumbers';
import AnnualSchedule from './components/AnnualSchedule';
import Device from './components/Device';
import styles from './index.module.scss';

const { Cell } = ResponsiveGrid;
function getObj() {
  return {
    display: true,
  };
}
const SmartBuildingAsset = () => {
  return (
    <>
      <ResponsiveGrid gap={20}>
        <Cell colSpan={12}>
          <PageHeader
            title="資產管理"
            breadcrumbs={[
              {
                name: '智慧建築專區',
              },
              {
                name: '資產管理',
              },
            ]}
          />
        </Cell>

        <Cell colSpan={12}>
          <Tab>
            <Tab.Item title="固定資產管理">
              <div className={styles.content}>
                <h2>資產管理</h2>
                <Device data={getObj()} showType={['非消耗品']} />
              </div>
              <div className={styles.content}>
                <h2>產權管理</h2>
                <ResidentAccountNumbers />
              </div>
            </Tab.Item>
            <Tab.Item title="租賃管理">
              <div className={styles.content}>
                <h2>公設預約列表</h2>
                <PublicAppointmentHomepage showButton={false} />
              </div>
              <div className={styles.content}>
                <h2>點數記錄列表</h2>
                <PointManagement showButton={false} />
              </div>
              <div className={styles.content}>
                <h2>公務車位租賃管理</h2>
                <LeaseManagement />
              </div>
              <div className={styles.content}>
                <h2>房仲帶看租售戶管理</h2>
                <RealEstateAgentManagement showHeader={false} />
              </div>
            </Tab.Item>
            <Tab.Item title="設施動態管理">
              <div className={styles.content}>
                <h2>設施動態排程</h2>
                <AnnualSchedule />
              </div>
              <div className={styles.content}>
                <h2>報修清單</h2>
                <Fix />
              </div>
              <div className={styles.content}>{/* <h2>報修進度</h2> */}</div>
            </Tab.Item>
          </Tab>
        </Cell>
      </ResponsiveGrid>
    </>
  );
};

export default SmartBuildingAsset;
